import { useContext } from "react";
import { I18nContext } from "react-i18next";

export default function useLocale() {
    const { i18n } = useContext(I18nContext);
    return i18n.language;
}
